import { EventToolbox } from 'client/utils/event-toolbox';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
import { EDIT_RESUBMIT } from 'site-modules/shared/constants/private-party/private-party';
import { TrackingConstant } from 'client/tracking/constant';
import {
  CREATIVE_ID_LISTING_API_POST,
  CREATIVE_ID_NOT_APPROVED_REASONS,
  CREATIVE_ID_API_PHOTOS,
  CREATIVE_ID_OWNER_ACTIONS_APPROVED,
  CREATIVE_ID_EDIT_PREVIEW,
  CREATIVE_ID_PARTNER_OFFER,
  CREATIVE_ID_EXISTING_LISTING_MODULE,
  CREATIVE_ID_CREATE_VEHICLE_DETAILS_COLOR,
  CREATIVE_ID_CREATE_PREVIEW,
  CREATIVE_ID_SUBMIT_LISTING,
} from 'site-modules/private-listing/constants/tracking';
import {
  CREATIVE_ID_EXPIRING_MODAL,
  CREATIVE_ID_CREATE_LISTING_VIN_ENTRY,
  CREATIVE_ID_OWNER_ACTIONS_NOT_APPROVED,
  CREATIVE_ID_SUMMARY_CHECKOUT,
  CREATIVE_ID_HOW_DID_YOU_SELL_YOUR_CAR_FEEDBACK,
  CREATIVE_ID_UCL_ENTRY_PRIVATE_PARTY,
  CREATIVE_ID_DEACTIVATION_SURVEY,
  CREATIVE_ID_CONTACT_FORM_TOGGLE,
  CREATIVE_ID_SUMMARY_MESSAGE,
} from 'client/site-modules/shared/constants/private-party/tracking';
import { APPRAISAL_OFFER_RENEWAL_CREATIVE_ID } from 'site-modules/shared/constants/appraisal/appraisal';
import { getCreativeId } from 'client/engagement-handlers/helper';
import { STATUS_SUCCESS } from 'site-modules/private-listing/constants/preview-step';

function fireWidgetViewTracking({ detail: { creativeId, actionCause, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    event_data: {
      action_name: TrackingConstant.ACTION_WIDGET_VIEW,
      action_cause: actionCause || TrackingConstant.ACTION_CAUSE_SCROLL,
      creative_id: creativeId,
      total_page_height: Math.max(document.body.scrollHeight, document.body.offsetHeight),
      ...(value ? { value } : {}),
    },
  });
}

function fireSignUpTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_SIGN_UP,
      action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: TrackingConstant.BEGIN_SIGN_UP,
      creative_id: creativeId,
    },
  });
}

function fireLicensePlateInputTracking({ detail: { isValidLicensePlate, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: isValidLicensePlate
        ? TrackingConstant.LICENSE_PLATE_INPUT_SUCCESS
        : TrackingConstant.LICENSE_PLATE_INPUT_FAILURE,
      creative_id: creativeId,
    },
  });
}

function fireLicensePlateStateTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.LICENSE_PLATE_STATE_SUCCESS,
      creative_id: creativeId,
    },
  });
}

function fireVinInputTracking({ detail: { isValidVin, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: isValidVin ? TrackingConstant.VIN_INPUT_SUCCESS : TrackingConstant.VIN_INPUT_FAILURE,
      creative_id: creativeId,
    },
  });
}

function fireListingStyleSelectTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.VEHICLE_STYLE_INPUT_SUCCESS,
      creative_id: creativeId,
    },
  });
}

function fireStyleDecodeOutcomeTracking({ detail: { value, creativeId } }) {
  let matchValue = 0;
  if (value === 1) {
    matchValue = 1;
  } else if (value > 1) {
    matchValue = 2;
  }
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_STYLE_DECODE,
      creative_id: creativeId,
      value: matchValue,
    },
  });
}

function fireSubmitVehicleDetailsTracking({ detail: { vehicleDetails, creativeId } }) {
  Object.keys(vehicleDetails).map(key =>
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
      event_data: {
        action_name: TrackingConstant.ACTION_FILL_FORM,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        subaction_name: key,
        creative_id: creativeId,
        value: vehicleDetails[key],
      },
    })
  );
}

function fireSubmitSellerDescriptionTracking({ detail: { characterCount, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBMIT_SELLER_DESCRIPTION,
      creative_id: creativeId,
      character_count: characterCount,
    },
  });
}

function fireSelectPhotosFilenamesTracking({ detail: { creativeId, subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: subactionName,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSelectPhotosTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.SUBACTION_SELECT_PHOTOS,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      creative_id: creativeId,
      value,
    },
  });
}

function fireRemovePhotoTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.SUBACTION_REMOVE_PHOTO,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      creative_id: creativeId,
    },
  });
}

function firePhotoUploadSystemErrorTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_PHOTO_UPLOAD_SYSTEM_ERROR,
      creative_id: CREATIVE_ID_API_PHOTOS,
      value,
    },
  });
}

function fireContinueTracking({ detail: { creativeId, subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function firePriceInputTracking({ detail: { status, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${TrackingConstant.PRICE_INPUT}_${status}`,
      creative_id: creativeId,
    },
  });
}

function fireSubmitListingTracking({ detail: { element, status, value } }) {
  const creativeId = getCreativeId(element);
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${TrackingConstant.SUBMIT_LISTING_FOR_APPROVAL}_${status}`,
      creative_id: creativeId,
      value,
    },
  });
}

function fireCheckoutListingTracking({ detail: { element, status, isAdhesionPanel } }) {
  const creativeId = getCreativeId(element);
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${isAdhesionPanel ? TrackingConstant.CHECKOUT_BUTTON_CLICK_ADHESION : TrackingConstant.CHECKOUT_BUTTON_CLICK}`,
      creative_id: creativeId,
      value: `Checkout_button_${status}`,
    },
  });
}

function fireSellerInfoInputTracking({ detail: { creativeId, isValid, name, actionCause } }) {
  const formatName = name?.replaceAll(/[A-Z](?=[a-z]*|$)|([A-Z])/g, match => `_${match}`)?.toLowerCase();
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: actionCause || TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${formatName}_input_${isValid ? 'success' : 'failure'}`,
      creative_id: creativeId,
    },
  });
}

function fireAPISystemErrorTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.API_SYSTEM_ERROR,
      creative_id: CREATIVE_ID_LISTING_API_POST,
      value,
    },
  });
}

function fireShareContentTracking({ detail: { creativeId, value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_SHARE_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSummaryCheckoutTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.CHECKOUT_DEEPLINK_STARTED,
      creative_id: creativeId,
      value,
    },
  });
}

function fireCreateDealTracking({ detail: { status, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: TrackingConstant.CHECKOUT_DEEPLINK_COMPLETED,
      creative_id: `${CREATIVE_ID_SUMMARY_CHECKOUT}-${status}`,
      value,
    },
  });
}

function fireManageListingTracking({ detail: { value, creativeId, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function fireWhyNotApprovedTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_SELLER_PRIVATE_PARTY_WHY_NOT_APPROVED,
      creative_id: CREATIVE_ID_OWNER_ACTIONS_NOT_APPROVED,
      value,
    },
  });
}

function fireNotApprovedBtnTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.MANAGE_PRIVATE_PARTY_LISTING,
      creative_id: CREATIVE_ID_NOT_APPROVED_REASONS,
      value: EDIT_RESUBMIT,
    },
  });
}

function fireStartPrivatePartyListingTracking({ detail: { value, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.START_PRIVATE_PARTY_LISTING,
      creative_id: creativeId,
      value,
    },
  });
}

function fireMoreOptionsTracking({ detail: { value, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: creativeId,
      subaction_name: TrackingConstant.SUBACTION_SELLER_MORE_OPTIONS_MENU,
      value,
    },
  });
}

function firePrivateListingManagementTracking({ detail: { subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: CREATIVE_ID_OWNER_ACTIONS_APPROVED,
      subaction_name: subactionName,
      value,
    },
  });
}

function fireStatusResult({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.EDIT_LISTING_STATUS_RESULT,
      creative_id: CREATIVE_ID_EDIT_PREVIEW,
      value,
    },
  });
}

function fireOfferTracking({ detail: { subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: subactionName,
      creative_id: CREATIVE_ID_PARTNER_OFFER,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      value,
    },
  });
}

function fireRenewListing({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.RENEW_LISTING,
      creative_id: creativeId,
      value,
    },
  });
}

function fireViewPartnerOfferTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      subaction_name: TrackingConstant.SUBACTION_VIEW_PARTNER_OFFER,
      creative_id: CREATIVE_ID_PARTNER_OFFER,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
      value: 'View Offer',
    },
  });
}

function firePartnerOfferActionTracking({ detail: { creativeId, value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      subaction_name: subactionName,
      creative_id: creativeId,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      value,
    },
  });
}

function firePartnerOfferDisplayedTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: TrackingConstant.SUBACTION_OFFER_DISPLAYED,
      creative_id: creativeId,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      value,
    },
  });
}

function firePartnerOfferValueTracking({ detail: { creativeId, value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: subactionName,
      creative_id: creativeId,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      value,
    },
  });
}

function fireEmoPartnerToSolicitTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: TrackingConstant.EMO_PARTNER_TO_SOLICIT,
      creative_id: CREATIVE_ID_PARTNER_OFFER,
      value,
    },
  });
}

function fireDisplayConditionQuestionsTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
      action_name: TrackingConstant.ACTION_SHOW_CONTENT,
      subaction_name: TrackingConstant.CONDITION_QUESTIONS_DISPLAYED,
      value: true,
    },
  });
}

function fireZipEditSuccessTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: TrackingConstant.ZIP_EDIT_SUCCESS,
      creative_id: CREATIVE_ID_CREATE_LISTING_VIN_ENTRY,
    },
  });
}

function fireDataPrefilledTracking({ detail: { creativeId, value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function fireOfferRenewalErrorTracking({ detail: { value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_RECEIVE_EPO,
      subaction_name: subactionName,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      creative_id: APPRAISAL_OFFER_RENEWAL_CREATIVE_ID,
      value,
    },
  });
}

function fireManageExistingListingTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.MANAGE_YOUR_LISTING,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: CREATIVE_ID_EXISTING_LISTING_MODULE,
      value,
    },
  });
}

function fireAddSellerNotesToggleTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.ADD_SELLER_NOTES_TOGGLE,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: CREATIVE_ID_CREATE_VEHICLE_DETAILS_COLOR,
      value,
    },
  });
}

function fireRetrieveFromModsIdTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.ENTERED_WITH_MODS_ID,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: CREATIVE_ID_CREATE_VEHICLE_DETAILS_COLOR,
      value,
    },
  });
}

function fireUnableRetrieveFromModsIdTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.UNABLE_RETRIEVE_FROM_MODS_ID,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      creative_id: CREATIVE_ID_CREATE_VEHICLE_DETAILS_COLOR,
      value,
    },
  });
}
function fireTabSelectTracking({ detail: { value, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.TAB_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSelectSellingMethodTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SELLING_METHOD,
      creative_id: creativeId,
      value,
    },
  });
}

function fireBuyPrivatePartyTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.BUY_PRIVATE_PARTY,
      creative_id: CREATIVE_ID_UCL_ENTRY_PRIVATE_PARTY,
      value,
    },
  });
}

function fireSoldToOtherSelectTracking({ detail: { value } }) {
  const subactionName = TrackingConstant.SOLD_TO_OTHER;
  const creativeId = CREATIVE_ID_HOW_DID_YOU_SELL_YOUR_CAR_FEEDBACK;

  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: subactionName,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: creativeId,
    },
  });

  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: subactionName,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSubmitFeedbackClickTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBMIT_FEEDBACK,
      creative_id: CREATIVE_ID_EXPIRING_MODAL,
      value,
    },
  });
}

function fireTransmissionTypeSourceTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.SUBMIT_LISTING_SUCCESS,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: TrackingConstant.TRANSMISSION_TYPE_SOURCE,
      creative_id: CREATIVE_ID_SUBMIT_LISTING,
      value,
    },
  });
}

function fireStripePaymentSuccessTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.STRIPE_PAYMENT_SUCCESS,
      action_cause: TrackingConstant.EVENT_TYPE_PAGE_ENTER,
      action_category: TrackingConstant.SYSTEM_ACTION_CAUSE,
      subaction_name: TrackingConstant.PAYMENT_SUCCESSFUL,
      creative_id: CREATIVE_ID_PARTNER_OFFER,
      value: `?checkout=${STATUS_SUCCESS}`,
    },
  });
}

function fireSendMessageTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_SEND_MESSAGE,
      creative_id: CREATIVE_ID_SUMMARY_MESSAGE,
      value,
    },
  });
}

function fireSendMessageSucceeded({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_SEND_MESSAGE_SUCCEEDED,
      creative_id: CREATIVE_ID_SUMMARY_MESSAGE,
      value,
    },
  });
}

function fireSendMessageFailed({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_SEND_MESSAGE_FAILED,
      creative_id: CREATIVE_ID_SUMMARY_MESSAGE,
      value,
    },
  });
}

function fireContactFormTabToggleTracking({ detail: { subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: CREATIVE_ID_CONTACT_FORM_TOGGLE,
      value,
    },
  });
}

function fireSubmitForApprovalTracking({ detail: { isStatusSuccess, value = 'Finish & Submit' } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${TrackingConstant.SUBMIT_LISTING_FOR_APPROVAL}_${isStatusSuccess ? 'succeeded' : 'failed'}`,
      creative_id: CREATIVE_ID_CREATE_PREVIEW,
      value,
    },
  });
}

function fireDeactivationSurveySelectReasonTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SELECT_DEACTIVATION_REASON,
      creative_id: CREATIVE_ID_DEACTIVATION_SURVEY,
      value,
    },
  });
}

function fireDeactivationSurveySubmitOtherTracking({ detail: { value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName || TrackingConstant.SUBMIT_OTHER_DETAILS,
      creative_id: CREATIVE_ID_DEACTIVATION_SURVEY,
      value,
    },
  });
}

function fireDeactivationSurveyCloseTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_SHOW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.CLOSE_POPUP,
      creative_id: CREATIVE_ID_DEACTIVATION_SURVEY,
      value: 'close',
    },
  });
}

function fireDeactivationSurveySelectHowSoldTracking({ detail: { value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: CREATIVE_ID_DEACTIVATION_SURVEY,
      value,
    },
  });
}

function fireDeactivationSurveySubmitFeedbackTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBMIT_SURVEY,
      creative_id: CREATIVE_ID_DEACTIVATION_SURVEY,
      value,
    },
  });
}

function fireActivityMetricsTracking({ detail: { value, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      creative_id: creativeId,
      value,
    },
  });
}

function fireOfferModalActivityTracking({ detail: { value, creativeId, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

export const PrivatePartyEngagementHandler = {
  init: () => {
    EventToolbox.on(PRIVATE_PARTY_EVENTS.WIDGET_VIEW, fireWidgetViewTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SIGN_UP, fireSignUpTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.ENTER_PLATE_INPUT, fireLicensePlateInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_STATE_INPUT, fireLicensePlateStateTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.VIN_INPUT, fireVinInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.LISTING_STYLE_SELECT, fireListingStyleSelectTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.STYLE_DECODE, fireStyleDecodeOutcomeTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_VEHICLE_DETAILS, fireSubmitVehicleDetailsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_SELLER_DESCRIPTION, fireSubmitSellerDescriptionTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_PHOTOS_FILENAMES, fireSelectPhotosFilenamesTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_PHOTOS, fireSelectPhotosTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.REMOVE_PHOTO, fireRemovePhotoTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CONTINUE, fireContinueTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PHOTO_UPLOAD_SYSTEM_ERROR, firePhotoUploadSystemErrorTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PRICE_INPUT, firePriceInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_LISTING, fireSubmitListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CHECKOUT_LISTING, fireCheckoutListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.MANAGE_LISTING, fireManageListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.WHY_NOT_APPROVED, fireWhyNotApprovedTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELLER_INFO_INPUT, fireSellerInfoInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.API_SYSTEM_ERROR, fireAPISystemErrorTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.NOT_APPROVED_BUTTON, fireNotApprovedBtnTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SHARE_CONTENT, fireShareContentTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUMMARY_CHECKOUT, fireSummaryCheckoutTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CREATE_DEAL, fireCreateDealTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.START_PP_LISTING, fireStartPrivatePartyListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.LISTING_OWNER_ACTIONS, firePrivateListingManagementTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.LISTING_MORE_ACTIONS_BTN, fireMoreOptionsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.STATUS_RESULT, fireStatusResult);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.RENEW_LISTING, fireRenewListing);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.OFFER_TRACKING, fireOfferTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.VIEW_PARTNER_OFFER, fireViewPartnerOfferTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.VIEW_PARTNER_OFFER_ACTION, firePartnerOfferActionTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PARTNER_OFFER_DISPLAYED, firePartnerOfferDisplayedTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PARTNER_OFFER_VALUE, firePartnerOfferValueTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.EMO_PARTNER_TO_SOLICIT, fireEmoPartnerToSolicitTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.DISPLAY_CONDITION_QUESTIONS, fireDisplayConditionQuestionsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.ZIP_EDIT_SUCCESS, fireZipEditSuccessTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.DATA_PREFILLED, fireDataPrefilledTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.OFFER_RENEWAL_ERROR, fireOfferRenewalErrorTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.MANAGE_EXISTING_LISTING, fireManageExistingListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.ADD_SELLER_NOTES_TOGGLE, fireAddSellerNotesToggleTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.RETRIEVE_FROM_MODS_ID, fireRetrieveFromModsIdTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.UNABLE_RETRIEVE_FROM_MODS_ID, fireUnableRetrieveFromModsIdTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.TAB_SELECT, fireTabSelectTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_SELLING_METHOD, fireSelectSellingMethodTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SOLD_TO_OTHER_SELECT, fireSoldToOtherSelectTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_FEEDBACK_CLICK, fireSubmitFeedbackClickTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.STRIPE_PAYMENT_SUCCESS, fireStripePaymentSuccessTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_LISTING_FOR_APPROVAL, fireSubmitForApprovalTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.BUY_PRIVATE_PARTY, fireBuyPrivatePartyTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.TRANSMISSION_TYPE_SOURCE, fireTransmissionTypeSourceTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.DEACTIVATION_SURVEY_SELECT_REASON, fireDeactivationSurveySelectReasonTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.DEACTIVATION_SURVEY_SUBMIT_OTHER, fireDeactivationSurveySubmitOtherTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.DEACTIVATION_SURVEY_CLOSE, fireDeactivationSurveyCloseTracking);
    EventToolbox.on(
      PRIVATE_PARTY_EVENTS.DEACTIVATION_SURVEY_SELECT_HOW_SOLD,
      fireDeactivationSurveySelectHowSoldTracking
    );
    EventToolbox.on(
      PRIVATE_PARTY_EVENTS.DEACTIVATION_SURVEY_SUBMIT_FEEDBACK,
      fireDeactivationSurveySubmitFeedbackTracking
    );
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SEND_MESSAGE, fireSendMessageTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SEND_MESSAGE_SUCCEEDED, fireSendMessageSucceeded);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SEND_MESSAGE_FAILED, fireSendMessageFailed);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CONTACT_FORM_TAB_TOGGLE, fireContactFormTabToggleTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.ACTIVITY_METRICS, fireActivityMetricsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.OFFER_MODAL_ACTIVITY, fireOfferModalActivityTracking);
  },
};
